import React from 'react';
import { CircleTopicFormat } from '@modernhealth/circles-graphql';
import { formatCircleFormat } from '@modernhealth/circles-web-components';
import { useTranslation } from 'react-i18next';

export const TranslatedCircleFormat = ({ format }: { format: CircleTopicFormat }) => {
    const { t } = useTranslation('circles');

    if (format === CircleTopicFormat.Fireside) {
        return (
            <>
                {t('Fireside Chat', {
                    ignoreJSONStructure: true,
                })}
            </>
        );
    }

    // t("Listen and Learn")
    // t("Discussion")
    // t("Workshop")
    return (
        <>
            {t(formatCircleFormat(format), {
                /* Our "keys" have spaces in them, so look them up directly.*/
                ignoreJSONStructure: true,
            })}
        </>
    );
};
